import { IPorousDesignImperial } from '@/modules/design/interfaces/porous';
import { UnitSystem } from '@/interfaces/units';
import { BaseScenarioType } from '@/lib/types/IBaseScenario';
import { DesignScenarioType, EsalCalculationMethods } from '@/modules/design/interfaces/shared';
import { IProjectMetadata } from '@/interfaces/report';
import {userStore} from "@/store/store";

export const createNewPorousScenario = function (project: IProjectMetadata): IPorousDesignImperial {
  return {
    id: -1,
    user: userStore.user ? userStore.user.id : null,
    project: project.id,
    created: new Date(Date.now()).toISOString(),
    modified: new Date(Date.now()).toISOString(),
    visible: true,
    displayUnits: project.displayUnits,
    unitSystem: UnitSystem.Imperial,
    scenarioType: BaseScenarioType.design,
    designScenarioType: DesignScenarioType.porous,
    isComputedFromLegacy: false,

    name: 'New Porous Pavement Design',
    description: null,
    state: project.state,

    completionYear: null,
    roadwayClassification: null,

    // Pavement Design
    pavementType: null,

    // Design Parameters
    designPeriod_years: 30, // Years
    reliabilityLevel: 90,
    standardError: 0.5,

    initialServiceability: 4.5,
    terminalServiceability: 3,
    deltaServiceability: null,

    // Traffic and Loading
    esalCalculatedFrom: EsalCalculationMethods.design,
    // From AADT
    initialTraffic: null,
    trafficGrowthRate: null,
    esalGrowthRate: null,


    // From ESALs
    esals: null,
    loadEquivalencyFactor: null,

    // From Design ESALs
    totalDesignEsals: null,

    layer_0_coefficient: null,
    layer_1_coefficient: null,
    layer_2_coefficient: null,


    // Layers
    layer_0_thickness_in: null,
    layer_1_thickness_in: null,
    layer_2_thickness_in: null,

    layer_1_modulus_psi: null,
    layer_2_modulus_psi: null,
    cbr: null,
    rValue: null,
    modulusCalculationMethod: null,

    loadDiameter_in: null,
  };
};
